import { Container } from '@pixi/display';

Container.prototype._renderCanvas = function _renderCanvas(_renderer) {
};
Container.prototype.renderCanvas = function renderCanvas(renderer) {
  if (!this.visible || this.worldAlpha <= 0 || !this.renderable) {
    return;
  }
  if (this._mask) {
    renderer.mask.pushMask(this._mask);
  }
  this._renderCanvas(renderer);
  for (let i = 0, j = this.children.length; i < j; ++i) {
    this.children[i].renderCanvas(renderer);
  }
  if (this._mask) {
    renderer.mask.popMask(renderer);
  }
};
//# sourceMappingURL=Container.mjs.map
